import axios from './configAxios';

export const getClientVehicles = async (id) => {
    return await axios.get(`vehicles/?limit=100&offset=0&client_id=${Number(id)}`);
};

